module.exports = __webpack_public_path__ + "static/media/sedona_log.dbbb0a46.png";